export default __webpack_public_path__ + "static/media/99.421a9073.jpg";